export const iconFontAwesomeEmojiFaceGrinTongueSquint = (
	<i className="fa-solid fa-face-grin-tongue-squint"></i>
);
